'use client';

import { useEffect, useState } from 'react';
import { formatCountdown } from './helpers';

export function useCountdown(resetsAt: string | null): string {
  const [value, setValue] = useState(() => formatCountdown(resetsAt));

  useEffect(() => {
    if (!resetsAt) return;
    setValue(formatCountdown(resetsAt));
    const interval = setInterval(() => {
      setValue(formatCountdown(resetsAt));
    }, 60_000);
    return () => clearInterval(interval);
  }, [resetsAt]);

  return value;
}
